// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__3Vkgx","btn":"Title_btn__1tpGa","icon":"Title_icon__2AxOG","wrapper":"Title_wrapper__6otAH"};